import Vue from 'vue';

Vue.prototype.$setFilename = function(name) {
    const slashCount = name.split('/').length - 1;

    if ( slashCount > 1 ) {
        const regex = /\([^)]+\)-(.*)/;
        const match = regex.exec(name);

        const parts = name.split('-');
        const filename = parts.pop().trim();

        return match ? match[1] : filename;
    } else {
        const newArr = name.split("-")
        newArr.shift()
        return newArr.join('-')
    }
};